export default __webpack_public_path__ + "static/char-s-18-en-1cc3fa09d4e07dd52a80f9e5b7c24dcb.webp";